const tenantId = process.env.REACT_APP_AZURE_AD_TENANT_ID ?? "";

export const authority = `https://login.microsoftonline.com/${tenantId}`;
export const clientId = process.env.REACT_APP_AZURE_AD_CLIENT_ID ?? "";

export const apiBaseUrl = process.env.REACT_APP_BACK_OFFICE_API_URL ?? "";
export const apiBaseScope = process.env.REACT_APP_BACKOFFICE_API_SCOPE_BASE ?? "";

export const environmentDisplayName = process.env.REACT_APP_ENVIRONMENT_DISPLAY_NAME ?? process.env.NODE_ENV;